<template>
    <div class="widget-time-relative w-full">
        <RedesignBaseSelect
            v-model="timeModel.Date_interval"
            placeholder="Select"
            class="w-full"
            :multiple="false"
            full-width
            @change="onChange"
        >
            <RedesignSelectOption
                v-for="(item, index) of widgetTimeOptions"
                :key="index"
                :label="$t(item.label)"
                :value="item.Date_interval"
            />
        </RedesignBaseSelect>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseSelect from '@/components/RedesignBaseComponents/Inputs/RedesignBaseSelect.vue'
import RedesignSelectOption from '@/components/RedesignBaseComponents/Inputs/RedesignSelectOption.vue'
import { WidgetTime } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
    value: WidgetTime
    widgetTimeOptions?: Array<Record<string, string>>
}>()
const emit = defineEmits([ 'input', 'update:value' ])

const timeModel = useVModel(props, 'value', emit, { eventName: 'input' })

function onChange (dateInterval: string) {
    const widgetTimeOption = props.widgetTimeOptions?.find(el => Number(el.Date_interval) === Number(dateInterval))
    if (widgetTimeOption) {
        timeModel.value.Date_interval = widgetTimeOption.Date_interval
        timeModel.value.datedeff = widgetTimeOption.datedeff
        timeModel.value.label = widgetTimeOption.label
    }
}

function initData () {
    const options = props.widgetTimeOptions || []
    const dateInterval = timeModel.value.Date_interval
    const isExistDateIntervalInRange = props.widgetTimeOptions?.find(el => el.Date_interval === dateInterval)
    const defaultDateInterval = isExistDateIntervalInRange ? isExistDateIntervalInRange.Date_interval : options[0]?.Date_interval
    const defaultDateDeff = isExistDateIntervalInRange ? isExistDateIntervalInRange.datedeff : options[0]?.datedeff
    const defaultDateLabel = isExistDateIntervalInRange ? isExistDateIntervalInRange.label : options[0]?.label

    timeModel.value.Date_interval = defaultDateInterval
    timeModel.value.datedeff = defaultDateDeff
    timeModel.value.label = defaultDateLabel
}

initData()
</script>

